import React, { useState, useRef, useEffect } from "react";
import ReportCard from "./report";
import Applicant from "./applicant";
import { useObserver } from "mobx-react";
import {
  FaCircleNotch,
  FaCheckCircle,
  FaMinusCircle,
  FaRegEdit,
  FaRegTrashAlt,
  FaExchangeAlt,
  FaRegKeyboard,
} from "react-icons/fa";
import {
  AiFillWarning,
  AiOutlineInfoCircle,
  AiOutlineFileText,
  AiOutlineComment,
  AiOutlineForm,
} from "react-icons/ai";
import { useStores } from "../../store";
import Behaviour from "../reusble_components/behavioural";
import MailPopup from "./MailPopup";
import ProxyReport from "../reusble_components/proxyReport/proxyReport";
import Tooltip from "../reusble_components/tooltip";
import TaskCard from "../reusble_components/TaskCard";
import { MdRefresh } from "react-icons/md";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import ProxyImagePopup from "./ProxyImagePopup";
import TextDetectionPopup from "./TextDetectionPopup";
import TabChangesPopup from "./TabChangesPopup";
import VerificationPopup from "./VerificationPopup";

const ReportOverview = ({
  candidate,
  reportData,
  videoData,
  loader,
  recruiter,
  proxy,
  enable,

  isHrInterviewCompleted,
  isJobPost = true,
}) => {
  const { RecuiterStore } = useStores();

  const reportData1 = Array.isArray(reportData) ? reportData : [];
  console.log(candidate, "reportData1");
  const videoData1 = Array.isArray(videoData) ? videoData : [];

  // Function to get formatted date and time
  const getFormattedDateTime = () => {
    const now = new Date();
    const day = now.getDate();
    const month = now
      .toLocaleString("default", { month: "short" })
      .toLowerCase();
    const year = now.getFullYear().toString().slice(-2);
    const hours = now.getHours().toString().padStart(2, "0");
    const minutes = now.getMinutes().toString().padStart(2, "0");
    return `${day} ${month}, ${year} at ${hours}:${minutes}`;
  };

  // Template options with timestamps
  const templates = {
    interview: `<h2>Interview Notes</h2>

<p><strong>Technical Assessment:</strong></p>
<ul>
  <li>Technical knowledge and skills</li>
  <li>Problem-solving abilities</li>
  <li>Code quality and best practices</li>
</ul>

<p><strong>Communication Skills:</strong></p>
<ul>
  <li>Clarity of expression</li>
  <li>Active listening</li>
  <li>Professional communication</li>
</ul>

<p><strong>Behavioral Assessment:</strong></p>
<ul>
  <li>Team collaboration</li>
  <li>Problem-solving approach</li>
  <li>Adaptability</li>
</ul>
<p><em><strong>Date: </strong>${getFormattedDateTime()}</em></p>`,
    feedback: `<h2>Application Feedback</h2>

<p><strong>Resume Review:</strong></p>
<ul>
  <li>Relevance of experience</li>
  <li>Skills alignment with role</li>
  <li>Career progression</li>
</ul>

<p><strong>Technical Evaluation:</strong></p>
<ul>
  <li>Required skills match</li>
  <li>Technical background</li>
  <li>Project experience</li>
</ul>

<p><strong>Overall Assessment:</strong></p>
<ul>
  <li>Fit for the role</li>
  <li>Growth potential</li>
  <li>Areas of concern</li>
</ul>
<p><em><strong>Date: </strong>${getFormattedDateTime()}</em></p>`,
    comments: `<h2>General Comments</h2>
<p><strong>Application Quality:</strong></p>
<ul>
  <li>Completeness of application</li>
  <li>Attention to detail</li>
  <li>Professional presentation</li>
</ul>

<p><strong>Additional Observations:</strong></p>
<ul>
  <li>Notable achievements</li>
  <li>Unique qualifications</li>
  <li>Special considerations</li>
</ul>

<p><strong>Follow-up Points:</strong></p>
<ul>
  <li>Questions to address</li>
  <li>Areas to explore further</li>
  <li>Next steps</li>
</ul>
<p><em><strong>Date: </strong>${getFormattedDateTime()}</em></p>`,
  };

  const [content, setContent] = useState(templates.interview);
  const [selectedTemplate, setSelectedTemplate] = useState("interview");
  const [loader1, setLoader1] = useState(false);
  const [sub, setSub] = useState("");
  const [editingFeedback, setEditingFeedback] = useState(null);
  const [editContent, setEditContent] = useState("");
  const [showAddNote, setShowAddNote] = useState(false);
  const [showFaceOutOfViewPopup, setShowFaceOutOfViewPopup] = useState(false);
  const [showMultipleFacesPopup, setShowMultipleFacesPopup] = useState(false);
  const [showTextDetectionPopup, setShowTextDetectionPopup] = useState(false);
  const [showTabChangesPopup, setShowTabChangesPopup] = useState(false);
  const [showVerificationPopup, setShowVerificationPopup] = useState(false);
  const [editingVerification, setEditingVerification] = useState(null);
  const [verificationData, setVerificationData] = useState(null);
  const [isUpdatingRestriction, setIsUpdatingRestriction] = useState(false);

  const quillRef = useRef();

  // Load verification data when component mounts or candidate changes
  useEffect(() => {
    if (candidate?.id && isJobPost) {
      loadVerificationData();
    }
  }, [candidate?.id, isJobPost]);

  const loadVerificationData = async () => {
    if (candidate?.id) {
      const result = await RecuiterStore.getVerificationByApplicationAndUser(
        candidate.id,
        candidate.userId || candidate._id,
      );
      if (result.success) {
        setVerificationData(result.data);
      }
    }
  };

  const updateCandidateStatus = (status) => {
    console.log(status);
    RecuiterStore.ChangeApplicantStatus(status);
  };
  const { CommonStore, PopupStore, InterviewStore } = useStores();
  const getTheResultByTopic = (topic) => {
    if (!candidate?.results || candidate?.results === "Pending") return "-";
    const results = Array.isArray(candidate?.results) ? candidate.results : [];
    const result = results.filter((q) => q?.name === topic);
    return result && result.length > 0 ? result[0]?.score : "0";
  };

  const message = `
Dear ${candidate.name},

I hope this message finds you well.  We are pleased to inform you that your application for the ${
    candidate.jobRole
  } position at ${
    JSON.parse(localStorage.getItem("user"))?.companyName
  } has been shortlisted. Your experience and qualifications caught our attention, and we are excited to learn more about you.

What's Next?
Our recruitment team will be reviewing your profile further, and you can expect to hear from us soon regarding the next steps in the selection process. This could include a phone interview, an assessment, or an in-person interview, depending on the role.

About ${JSON.parse(localStorage.getItem("user"))?.companyName}:
At ${
    JSON.parse(localStorage.getItem("user"))?.companyName
  }, we are passionate about [briefly describe what your company does, its mission, or values]. We are excited about the prospect of adding someone with your skills and experience to our team.

Contact Information:
If you have any questions in the meantime, please feel free to reach out to us at ${
    JSON.parse(localStorage.getItem("user"))?.mail
  } or call us at ${
    JSON.parse(localStorage.getItem("user"))?.mobile
  }. We are here to help!

Thank you once again for your interest in joining ${
    JSON.parse(localStorage.getItem("user"))?.companyName
  }. We appreciate the time and effort you've invested in applying and look forward to progressing your application further.

`;
  const subject = `Congratulations! You've Been Shortlisted for ${
    candidate.jobRole
  } at ${JSON.parse(localStorage.getItem("user"))?.companyName}!`;
  const Rejectsubject = `Update on Your Application for ${
    candidate.jobRole
  } at ${JSON.parse(localStorage.getItem("user"))?.companyName}`;

  const Rejectmessage = `
Dear ${candidate.name},

Thank you for your interest in the ${candidate.jobRole} position at ${
    JSON.parse(localStorage.getItem("user"))?.companyName
  }. After careful consideration, we regret to inform you that we will not be moving forward with your application at this time.

We appreciate the time and effort you invested in the process, and we encourage you to apply for future opportunities that align with your skills and experience.

`;

  const shouldShowSomething = (reportData1) => {
    for (let i = 1; i <= 3; i++) {
      const item = reportData1[i];
      if (item?.show) {
        if (item.score === null) {
          return true;
        }
        return true;
      }
    }
    return true; // Default if none of the items are shown
  };

  const handleEditFeedback = (feedback, index) => {
    setEditingFeedback(index);
    setEditContent(feedback.feedback);
  };

  const handleDeleteFeedback = async (index) => {
    const updatedFeedback = candidate.interviewFeedback.filter(
      (_, i) => i !== index,
    );
    const response = await RecuiterStore.updateApplicantInterviewFeedback(
      candidate.id,
      updatedFeedback,
    );

    if (response) {
      RecuiterStore.fetchApplicantDetails(candidate.id);
    }
  };

  const handleUpdateFeedback = async (index) => {
    const updatedFeedback = [...candidate.interviewFeedback];
    updatedFeedback[index] = {
      ...updatedFeedback[index],
      feedback: editContent,
    };

    const response = await RecuiterStore.updateApplicantInterviewFeedback(
      candidate.id,
      updatedFeedback,
    );

    if (response) {
      setEditingFeedback(null);
      setEditContent("");
      RecuiterStore.fetchApplicantDetails(candidate.id);
    }
  };

  const quillModules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ indent: "-1" }, { indent: "+1" }],
      ["link"],
      ["clean"],
    ],
  };

  const quillFormats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "list",
    "bullet",
    "indent",
    "link",
  ];

  const handleTemplateChange = (template) => {
    setSelectedTemplate(template);
    // Update the template with current timestamp
    const templateWithTimestamp = templates[template].replace(
      /<p><em>Added on .*?<\/em><\/p>/,
      `<p><em>Added on ${getFormattedDateTime()}</em></p>`,
    );
    setContent(templateWithTimestamp);
  };

  const handleRemoveVerification = async (verificationToRemove) => {
    // Show confirmation dialog
    const confirmed = window.confirm(
      `Are you sure you want to remove the verification "${verificationToRemove.name}"? This action cannot be undone.`,
    );

    if (!confirmed) return;

    try {
      // Get the current verification document
      const currentVerificationData =
        await RecuiterStore.getVerificationByApplicationAndUser(
          candidate?.id,
          candidate?.userId || candidate?._id,
        );

      if (!currentVerificationData.success) {
        alert("Failed to fetch current verification data.");
        return;
      }

      // Filter out the specific verification to remove
      // Use both verificationType and createdAt to uniquely identify the verification
      const updatedVerifications =
        currentVerificationData.data.verifications.filter((verification) => {
          return !(
            verification.verificationType ===
              verificationToRemove.verificationType &&
            verification.createdAt === verificationToRemove.createdAt
          );
        });

      console.log("Removing verification:", {
        verificationToRemove,
        originalCount: currentVerificationData.data.verifications.length,
        newCount: updatedVerifications.length,
      });

      // If no verifications left, set overallStatus to 0 (Pending)
      const newOverallStatus =
        updatedVerifications.length === 0
          ? 0
          : currentVerificationData.data.overallStatus;

      // Prepare the complete document data for update
      const completeDocumentData = {
        overallStatus: newOverallStatus,
        verifications: updatedVerifications,
        globalNotes: currentVerificationData.data.globalNotes || [],
      };

      // Update the verification document
      const result = await RecuiterStore.updateVerification(
        verificationData._id,
        completeDocumentData,
      );

      if (result.success) {
        // Update local state
        setVerificationData(result.data);
        alert("Verification removed successfully!");
      } else {
        alert(result.message || "Failed to remove verification");
      }
    } catch (error) {
      console.error("Error removing verification:", error);
      alert("An error occurred while removing verification");
    }
  };

  return useObserver(() => (
    <div className="flex min-w-0 w-full flex-col">
      {/* <Loader loader={loader} /> */}
      <div
        className={` gil-reg w-full h-full   relative ${
          PopupStore.mail && "overflow-hidden"
        } `}
      >
        <MailPopup
          report={true}
          jobRole={candidate.jobRole}
          id={candidate._id}
          emails={[candidate.email]}
          sub={sub}
          mess={content}
        />

        {(loader || RecuiterStore.showLoader || RecuiterStore.loader) && (
          <div className="absolute inset-0 flex items-center justify-center z-50">
            <div className="flex flex-col items-center">
              <FaCircleNotch className="animate-spin text-primary text-4xl mb-2" />
              <p>Loading...</p>
            </div>
          </div>
        )}
        <div className="md:hidden lg:hidden block "></div>

        {/* <div className="flex justify-between w-[95%] items-center ">
          <h2 className="text-xl flex items-center gap-4 font-semibold mb-4 pt-4 pl-4 md:pt-8 md:pl-8 mx-2 sm:mx-8 md:mx-8 lg:mx-14">
            Overview{" "}
            <p className="text-[#747474] md:block lg:block hidden opacity-50 text-sm font-semibold">
              Id : {candidate.id}
            </p>
          </h2>

          <button
          //   className="flex flex-row items-center justify-around gap-1 border border-primary px-4 text-primary h-8 rounded-lg text-sm"
          //   onClick={() => {
          //     CommonStore.setResume(true);
          //   }}
          // >
          //   <AiOutlineFileText />
          //   Resume
          // </button>
        </div>
        <p className="text-[#747474] md:hidden pt-4 pl-4 lg:hidden block opacity-50 mb-2 mx-2 text-sm font-semibold">
          Id : {candidate.id}
        </p> */}
        <div className="rounded-lg md:mb-5 mb-20  ">
          <Applicant
            candidate={candidate}
            recruiter={recruiter}
            reportData={reportData}
            enable={enable}
            isJobPost={isJobPost}
          />

          {/* Restriction Access Card */}
          {isJobPost && candidate?.isRestricted && (
            <div className="shadow-lg bg-white mb-5">
              <div className="p-4 md:p-6 md:ml-3">
                <div className="bg-orange-50 border-l-4 border-orange-400 p-4 rounded-r-lg">
                  <div className="flex items-start justify-between">
                    <div className="flex items-start gap-3 flex-1">
                      <AiFillWarning className="text-orange-400 text-2xl flex-shrink-0 mt-0.5" />
                      <div className="flex-1">
                        <h3 className="text-lg font-semibold text-gray-800 mb-1">
                          Assessment Access Restricted
                        </h3>
                        <p className="text-sm text-gray-600 mb-3">
                          This candidate's access to assessments is currently
                          restricted. Click the button below to grant them
                          access to take the assessments.
                        </p>
                        <button
                          onClick={async () => {
                            if (
                              window.confirm(
                                "Are you sure you want to grant access to this candidate to take assessments?",
                              )
                            ) {
                              setIsUpdatingRestriction(true);
                              const response =
                                await RecuiterStore.updateApplicantRestriction(
                                  candidate.id,
                                  false,
                                );
                              setIsUpdatingRestriction(false);
                              if (response) {
                                alert(
                                  "Access granted successfully! The candidate can now take assessments.",
                                );
                                RecuiterStore.fetchApplicantDetails(
                                  candidate.id,
                                );
                              } else {
                                alert(
                                  "Failed to grant access. Please try again later.",
                                );
                              }
                            }
                          }}
                          disabled={isUpdatingRestriction}
                          className="bg-primary text-white px-4 py-2 rounded-md hover:bg-primary/90 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
                        >
                          {isUpdatingRestriction ? (
                            <>
                              <FaCircleNotch className="animate-spin" />
                              Granting Access...
                            </>
                          ) : (
                            <>
                              <FaCheckCircle />
                              Grant Access to Assessments
                            </>
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {isHrInterviewCompleted && (
            <div>
              <Behaviour
                professionalScore={getTheResultByTopic("professionalism_score")}
                positivenessScore={getTheResultByTopic("positiveness_score")}
                // communicationScore={getTheResultByTopic("communication_score")}
                sociabilityScore={getTheResultByTopic("sociability_score")}
              />
            </div>
          )}

          {candidate?.preScreeningAnswers &&
            candidate?.preScreeningAnswers?.length > 0 && (
              <div className="shadow-lg bg-white pb-20 md:pb-0">
                <div className="p-3 md:p-4 lg:p-4 md:ml-3">
                  <div className="flex justify-between items-center mb-4">
                    <h1 className="text-xl gil-med">Pre-Screening Answers</h1>
                    <div className="flex items-center gap-2">
                      <span className="text-sm text-gray-600">
                        Total Questions:
                      </span>
                      <span className="font-medium">
                        {candidate?.preScreeningAnswers?.length}
                      </span>
                    </div>
                  </div>
                  <div className="flex flex-col gap-4">
                    {candidate?.preScreeningAnswers?.map((item, index) => (
                      <div
                        key={item._id}
                        className="border rounded-lg p-4 hover:shadow-md transition-shadow"
                      >
                        <div className="flex items-start gap-3">
                          <div className="flex-shrink-0 w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center">
                            <span className="text-primary font-medium">
                              {index + 1}
                            </span>
                          </div>
                          <div className="flex-1">
                            <div className="flex items-start justify-between">
                              <h3 className="text-base font-medium text-gray-800 mb-2">
                                {item.question}
                              </h3>
                              <div className="flex gap-2 items-center">
                                <div className="flex items-center gap-1">
                                  <span className="text-sm text-gray-600">
                                    Type:
                                  </span>
                                  <span className="text-sm font-medium capitalize">
                                    {item.answerType}
                                  </span>
                                </div>
                                <span
                                  className={`px-3 py-1 rounded-full text-sm font-medium ${
                                    item.isQualified
                                      ? "bg-green-100 text-green-800"
                                      : "bg-red-100 text-red-800"
                                  }`}
                                >
                                  {item.isQualified
                                    ? "Qualified"
                                    : "Not Qualified"}
                                </span>
                              </div>
                            </div>
                            <div className=" space-y-2">
                              <div className="flex items-start gap-2">
                                <span className="text-sm text-gray-600">
                                  Answer:
                                </span>
                                <p className="text-sm text-gray-800">
                                  {item.answer}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}

          <div className="shadow-lg bg-white pb-20 md:pb-0">
            <div className="md:p-4 lg:p-4  md:ml-3">
              {candidate?.assessment?.show ? (
                <div className="border-b-2 border-dashed mb-4">
                  <TaskCard
                    assessment={candidate?.assessment}
                    applicationId={candidate?.id}
                    startedAt={candidate?.createdAt}
                    submittedAt={candidate?.updatedAt}
                  />
                </div>
              ) : null}
              {/* <h2 className="text-xl font-semibold mb-4">Scores</h2> */}
              {reportData1.map((report, index) => (
                <React.Fragment key={report._id || index}>
                  {report.title === "Salary Recommendation System" ||
                  !report.show ? null : (
                    <ReportCard
                      {...report}
                      enable={enable}
                      isJobPost={isJobPost}
                      candidate={candidate}
                    />
                  )}
                </React.Fragment>
              ))}
              {/* {shouldShowSomething(reportData1) && ( */}
              {isJobPost && (
                <div className="border-b-2 border-dashed">
                  {candidate?.applicationEvaluation?.positives &&
                  Array.isArray(candidate?.applicationEvaluation?.positives) &&
                  candidate?.applicationEvaluation?.positives.length > 0 &&
                  candidate?.applicationEvaluation?.positives !== "" ? (
                    <div className="w-full px-4 md:px-0 mt-8">
                      <h1 className="text-xl  gil-med mb-2 md:mb-3">
                        Strengths
                      </h1>
                      <div className="flex flex-col gap-3 md:gap-4">
                        {candidate?.applicationEvaluation?.positives?.map(
                          (report, index) => (
                            <div
                              key={report._id || index}
                              className="flex items-start"
                            >
                              <FaCheckCircle className="text-green-500 min-w-[16px] md:min-w-[20px] mt-1 mr-2 md:mr-3 text-sm md:text-base" />
                              <p className="text-sm md:text-base">{report}</p>
                            </div>
                          ),
                        )}
                      </div>
                    </div>
                  ) : (
                    <div className="flex items-center justify-between py-4 px-2 md:px-0">
                      <h2 className="text-xl gil-med ">
                        Strengths & Areas of improvement
                      </h2>
                      <button
                        className=" text-primary flex items-center hover:underline"
                        onClick={async () => {
                          setLoader1(true);
                          if (
                            !(reportData[3]?.show
                              ? reportData[3]?.isCompleted
                              : reportData[2]?.isCompleted)
                          ) {
                            const confirm = window.confirm(
                              "Candidate has not completed the assessment yet. Do you want to generate report anyway?",
                            );
                            if (confirm) {
                              const response =
                                await RecuiterStore.generateEvaluation(
                                  candidate?.id,
                                );
                              if (response) {
                                console.log(
                                  "Evaluation generated successfully",
                                );
                                RecuiterStore.fetchApplicantDetails(
                                  candidate?.id,
                                );
                              } else {
                                console.log("Failed to generate evaluation");
                              }
                            }
                          } else {
                            const response =
                              await RecuiterStore.generateEvaluation(
                                candidate?.id,
                              );
                            if (response) {
                              console.log("Evaluation generated successfully");
                              RecuiterStore.fetchApplicantDetails(
                                candidate?.id,
                              );
                            } else {
                              console.log("Failed to generate evaluation");
                            }
                          }
                          setLoader1(false);
                        }}
                      >
                        {loader1 ? (
                          <MdRefresh className="mr-1 animate-spin" />
                        ) : (
                          <MdRefresh className="mr-1" />
                        )}
                        Generate
                      </button>
                    </div>
                  )}
                  {candidate?.applicationEvaluation?.negatives &&
                  Array.isArray(candidate?.applicationEvaluation?.negatives) &&
                  candidate?.applicationEvaluation?.negatives.length > 0 &&
                  candidate?.applicationEvaluation?.negatives !== "" ? (
                    <div className="w-full py-6 md:py-10 pt-4 md:pt-6  px-4 md:px-0">
                      <h1 className="text-xl  gil-med mb-2  md:mb-3">
                        Areas of improvement
                      </h1>
                      <div className="flex flex-col gap-3 md:gap-4">
                        {candidate?.applicationEvaluation?.negatives?.map(
                          (report, index) => (
                            <div
                              key={report._id || index}
                              className="flex items-start"
                            >
                              <FaMinusCircle className="text-red-500 min-w-[16px] md:min-w-[20px] mt-1 mr-2 md:mr-3 text-sm md:text-base" />
                              <p className="text-sm md:text-base">{report}</p>
                            </div>
                          ),
                        )}
                      </div>
                    </div>
                  ) : null}
                </div>
              )}

              {/* Proxy */}
              {candidate.proxy?.isOverallProxy ? (
                candidate.proxyId && candidate.proxyId !== "" ? (
                  <div className="border-b-2 border-dashed">
                    <div className="w-full px-2 md:px-0 py-4">
                      <div className="flex items-center gap-2 mb-4">
                        <h2 className="text-lg font-semibold text-gray-900">
                          Proxy Detection
                        </h2>
                        <span className="bg-blue-100 text-blue-800 text-[10px] font-medium px-2 py-0.5 rounded-full">
                          BETA
                        </span>
                      </div>
                      <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
                        {/* Tab Changes */}
                        <div
                          className={`flex items-center justify-between border rounded-lg px-3 py-2 bg-white ${
                            candidate.proxy.tabChanges > 0
                              ? "cursor-pointer"
                              : "cursor-not-allowed"
                          }`}
                          onClick={() => {
                            if (candidate.proxy.tabChanges > 0) {
                              setShowTabChangesPopup(true);
                            }
                          }}
                        >
                          <div className="flex items-center gap-2">
                            <FaExchangeAlt className="text-green-800 text-base" />
                            <span className="text-sm font-semibold text-gray-900">
                              Tab Changes
                            </span>
                          </div>
                          {candidate.proxy.tabChanges > 0 ? (
                            <span className="bg-red-100 text-red-700 font-semibold px-2 py-0.5 rounded flex items-center text-xs">
                              {candidate.proxy.tabChanges} Times
                              <span className="ml-1 text-base">🚩</span>
                            </span>
                          ) : (
                            <span className="bg-green-100 text-green-700 font-semibold px-2 py-0.5 rounded flex items-center text-xs">
                              No <FaCheckCircle className="ml-1" />
                            </span>
                          )}
                        </div>
                        {/* Copy-paste detected */}
                        <div
                          className={`flex items-center justify-between border rounded-lg px-3 py-2 bg-white ${
                            candidate.proxy.textDetection > 0
                              ? "cursor-pointer"
                              : "cursor-not-allowed"
                          }`}
                          onClick={() => {
                            if (candidate.proxy.textDetection > 0) {
                              setShowTextDetectionPopup(true);
                            }
                          }}
                        >
                          <div className="flex items-center gap-2">
                            <FaRegKeyboard className="text-green-800 text-base" />
                            <span className="text-sm font-semibold text-gray-900">
                              Copy-Paste Detected
                            </span>
                          </div>
                          {candidate.proxy.textDetection > 0 ? (
                            <span className="bg-red-100 text-red-700 font-semibold px-2 py-0.5 rounded flex items-center text-xs">
                              {candidate.proxy.textDetection} Times
                              <span className="ml-1 text-base">🚩</span>
                            </span>
                          ) : (
                            <span className="bg-green-100 text-green-700 font-semibold px-2 py-0.5 rounded flex items-center text-xs">
                              No <FaCheckCircle className="ml-1" />
                            </span>
                          )}
                        </div>
                        {/* External monitor detected */}
                        {/* <div className="flex items-center justify-between border rounded-lg px-3 py-2 bg-white">
                        <div className="flex items-center gap-2">
                          <AiOutlineInfoCircle className="text-green-800 text-base" />
                          <span className="text-sm font-semibold text-gray-900">
                            External monitor detected
                          </span>
                        </div>
                        <span className="bg-green-100 text-green-700 font-semibold px-2 py-0.5 rounded flex items-center text-xs">
                          No <FaCheckCircle className="ml-1" />
                        </span>
                      </div>  */}
                        {/* Face intermittently out of view */}
                        <div
                          className={`flex items-center justify-between border rounded-lg px-3 py-2 bg-white  ${
                            candidate.proxy.faceOutOfView > 0
                              ? "cursor-pointer"
                              : "cursor-not-allowed"
                          }`}
                          onClick={() => {
                            if (candidate.proxy.faceOutOfView > 0) {
                              setShowFaceOutOfViewPopup(true);
                            }
                          }}
                        >
                          <div className="flex items-center gap-2">
                            <AiOutlineInfoCircle className="text-green-800 text-base" />
                            <span className="text-sm font-semibold text-gray-900">
                              Face Movements
                            </span>
                          </div>
                          {candidate.proxy.faceOutOfView > 0 ? (
                            <span className="bg-red-100 text-red-700 font-semibold px-2 py-0.5 rounded flex items-center text-xs">
                              {candidate.proxy.faceOutOfView} Times
                              <span className="ml-1 text-base">🚩</span>
                            </span>
                          ) : (
                            <span className="bg-green-100 text-green-700 font-semibold px-2 py-0.5 rounded flex items-center text-xs">
                              No <FaCheckCircle className="ml-1" />
                            </span>
                          )}
                        </div>
                        {/* Multiple faces detected */}
                        <div
                          className={`flex items-center justify-between border rounded-lg px-3 py-2 bg-white ${
                            candidate.proxy.multipleFacesDetected > 0
                              ? "cursor-pointer"
                              : "cursor-not-allowed"
                          }`}
                          onClick={() => {
                            if (candidate.proxy.multipleFacesDetected > 0) {
                              setShowMultipleFacesPopup(true);
                            }
                          }}
                        >
                          <div className="flex items-center gap-2">
                            <AiOutlineInfoCircle className="text-green-800 text-base" />
                            <span className="text-sm font-semibold text-gray-900">
                              Multiple faces detected
                            </span>
                          </div>
                          {candidate.proxy.multipleFacesDetected > 0 ? (
                            <span className="bg-red-100 text-red-700 font-semibold px-2 py-0.5 rounded flex items-center text-xs">
                              {candidate.proxy.multipleFacesDetected} Times
                              <span className="ml-1 text-base">🚩</span>
                            </span>
                          ) : (
                            <span className="bg-green-100 text-green-700 font-semibold px-2 py-0.5 rounded flex items-center text-xs">
                              No <FaCheckCircle className="ml-1" />
                            </span>
                          )}
                        </div>
                        {/* Multiple voices detected */}
                        {/* <div className="flex items-center justify-between border rounded-lg px-3 py-2 bg-white">
                          <div className="flex items-center gap-2">
                            <FaRegKeyboard className="text-green-800 text-base" />
                            <span className="text-sm font-semibold text-gray-900">
                              Multiple voices detected
                            </span>
                          </div>
                          {candidate.proxy.multipleVoicesDetected > 0 ? (
                            <span className="bg-red-100 text-red-700 font-semibold px-2 py-0.5 rounded flex items-center text-xs">
                              {candidate.proxy.multipleVoicesDetected} Times
                              <span className="ml-1 text-base">🚩</span>
                            </span>
                          ) : (
                            <span className="bg-green-100 text-green-700 font-semibold px-2 py-0.5 rounded flex items-center text-xs">
                              No <FaCheckCircle className="ml-1" />
                            </span>
                          )}
                        </div> */}
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="flex justify-between items-start w-full bg-white rounded-lg ">
                    <div className="w-full">
                      <div className="flex w-full items-center justify-between mb-4">
                        <h3 className="text-xl font-semibold text-gray-800">
                          Proxy Detection
                        </h3>
                        <span className="bg-blue-100 text-blue-800 text-[10px] font-medium px-2 py-0.5 rounded-full">
                          BETA
                        </span>
                      </div>

                      <div className="bg-orange-50 border-l-4 border-orange-400 p-4 rounded-r-lg">
                        <div className="md:flex items-center justify-between">
                          <div className="flex items-center gap-3">
                            <AiFillWarning className="text-orange-400 text-2xl flex-shrink-0" />
                            <span className="text-gray-700 font-medium">
                              Proxy Not Detected
                            </span>
                          </div>
                        </div>
                        <div className="mt-4 flex flex-col gap-2">
                          <p className="text-sm text-gray-600">
                            The candidate has not completed the above
                            assessments.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              ) : null}

              {/* Verification Section */}
              {isJobPost && (
                <div className="border-b-2 border-dashed">
                  <div className="w-full px-2 md:px-0 py-6">
                    <div className="flex items-center justify-between mb-4">
                      <div className="flex items-center gap-2">
                        <h2 className="text-xl gil-med">Verification Status</h2>
                        <Tooltip
                          id="verification-tooltip"
                          content={
                            <span>
                              Track and manage verification documents for this
                              candidate, including education, experience,
                              criminal checks, and other verification types.
                            </span>
                          }
                          position="right"
                        >
                          <AiOutlineInfoCircle className="text-primary cursor-pointer text-lg" />
                        </Tooltip>
                      </div>
                      <button
                        className="flex items-center gap-2 px-3 py-1 text-sm bg-primary text-white rounded-md shadow hover:bg-primary/90 transition"
                        onClick={() => {
                          setEditingVerification(null);
                          setShowVerificationPopup(true);
                        }}
                      >
                        <span className="text-lg font-bold">+</span> Add
                        Verification
                      </button>
                    </div>

                    {/* Verification Status Display */}
                    <div className="space-y-4">
                      {verificationData && verificationData.verifications ? (
                        verificationData.verifications.map(
                          (verification, index) => (
                            <div
                              key={index}
                              className="bg-white border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow"
                            >
                              <div className="flex items-start justify-between">
                                <div className="flex-1">
                                  <div className="flex items-center gap-3 mb-2">
                                    <h3 className="text-lg font-semibold text-gray-900">
                                      {verification.name}
                                    </h3>
                                    <span
                                      className={`px-2 py-1 rounded-full text-xs font-medium ${
                                        verification.status === 0
                                          ? "bg-yellow-100 text-yellow-800"
                                          : verification.status === 1
                                            ? "bg-green-100 text-green-800"
                                            : verification.status === 2
                                              ? "bg-gray-100 text-gray-800"
                                              : verification.status === 3
                                                ? "bg-red-100 text-red-800"
                                                : "bg-blue-100 text-blue-800"
                                      }`}
                                    >
                                      {verification.status === 0
                                        ? "Pending"
                                        : verification.status === 1
                                          ? "Verified"
                                          : verification.status === 2
                                            ? "Unverified"
                                            : verification.status === 3
                                              ? "Rejected"
                                              : "Under Review"}
                                    </span>
                                    {/* <span
                                    className={`px-2 py-1 rounded-full text-xs font-medium ${
                                      verification.priority === "low"
                                        ? "bg-gray-100 text-gray-800"
                                        : verification.priority === "medium"
                                        ? "bg-yellow-100 text-yellow-800"
                                        : verification.priority === "high"
                                        ? "bg-orange-100 text-orange-800"
                                        : "bg-red-100 text-red-800"
                                    }`}
                                  >
                                    {verification.priority.toUpperCase()}
                                  </span> */}
                                  </div>
                                  <p className="text-sm text-gray-600 mb-2">
                                    {verification.description}
                                  </p>
                                  <div className="text-xs flex w-full justify-start gap-3 text-gray-500">
                                    <p>
                                      <strong>Type:</strong>{" "}
                                      {verification.verificationType
                                        .replace("_", " ")
                                        .toUpperCase()}
                                    </p>
                                    {verification.verifiedBy?.name && (
                                      <p>
                                        <strong>Verified by:</strong>{" "}
                                        {verification.verifiedBy.name}
                                        {verification.verifiedBy.role &&
                                          ` (${verification.verifiedBy.role})`}
                                      </p>
                                    )}
                                    {verification.proof &&
                                      verification.proof.length > 0 && (
                                        <div>
                                          <p className="mb-1">
                                            <strong>Proof documents:</strong>{" "}
                                            {verification.proof.length}
                                          </p>
                                          <div className="flex flex-wrap gap-1">
                                            {verification.proof.map(
                                              (proof, proofIndex) => (
                                                <button
                                                  key={proofIndex}
                                                  onClick={() =>
                                                    window.open(
                                                      proof.url,
                                                      "_blank",
                                                    )
                                                  }
                                                  className="text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded hover:bg-blue-200 transition-colors"
                                                  title={`${
                                                    proof.name
                                                  } - ${proof.type.toUpperCase()}`}
                                                >
                                                  {proof.name.length > 20
                                                    ? `${proof.name.substring(
                                                        0,
                                                        20,
                                                      )}...`
                                                    : proof.name}
                                                </button>
                                              ),
                                            )}
                                          </div>
                                        </div>
                                      )}
                                  </div>
                                </div>
                                <div className="flex gap-2 ml-4">
                                  <button
                                    onClick={() => {
                                      // Pass the individual verification data along with the parent verification document ID
                                      // Include createdAt as unique identifier for verifications of same type
                                      const editData = {
                                        ...verification,
                                        parentVerificationId:
                                          verificationData._id,
                                        createdAt: verification.createdAt, // Ensure createdAt is included
                                      };
                                      console.log(
                                        "Setting editing verification:",
                                        {
                                          verification,
                                          verificationData,
                                          editData,
                                        },
                                      );
                                      setEditingVerification(editData);
                                      setShowVerificationPopup(true);
                                    }}
                                    className="p-2 rounded-full hover:bg-primary/10 transition"
                                    title="Edit Verification"
                                  >
                                    <FaRegEdit className="text-primary text-sm" />
                                  </button>
                                  <button
                                    onClick={() =>
                                      handleRemoveVerification(verification)
                                    }
                                    className="p-2 rounded-full hover:bg-red-100 transition"
                                    title="Remove Verification"
                                  >
                                    <FaRegTrashAlt className="text-red-600 text-sm" />
                                  </button>
                                  {/* <button
                                  onClick={() => {
                                    // Handle status update
                                    const newStatus = verification.status === 1 ? 0 : 1;
                                    RecuiterStore.updateVerificationStatus(
                                      verificationData._id,
                                      verification.verificationType,
                                      newStatus
                                    ).then((result) => {
                                      if (result.success) {
                                        setVerificationData(result.data);
                                      }
                                    });
                                  }}
                                  className={`p-2 rounded-full transition ${
                                    verification.status === 1
                                      ? "hover:bg-yellow-100"
                                      : "hover:bg-green-100"
                                  }`}
                                  title={verification.status === 1 ? "Mark as Pending" : "Mark as Verified"}
                                >
                                  {verification.status === 1 ? (
                                    <FaMinusCircle className="text-yellow-600 text-sm" />
                                  ) : (
                                    <FaCheckCircle className="text-green-600 text-sm" />
                                  )}
                                </button> */}
                                </div>
                              </div>
                            </div>
                          ),
                        )
                      ) : (
                        <div className="text-center py-8 text-gray-500">
                          <p>No verification documents found.</p>
                          <p className="text-sm">
                            Click "Add Verification" to get started.
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {/* Interview Feedback Section */}
              {isJobPost && (
                <div className="border-b-2 border-dashed">
                  <div className="w-full px-2 md:px-0 py-6">
                    <div className="flex items-center justify-between mb-4">
                      <div className="flex items-center gap-2">
                        <h2 className="text-xl gil-med">Application Notes</h2>
                        <Tooltip
                          id="interview-feedback-tooltip"
                          content={
                            <span>
                              Use this section to provide detailed feedback
                              about the candidate's interview performance,
                              including technical skills, communication, and
                              overall assessment.
                            </span>
                          }
                          position="right"
                        >
                          <AiOutlineInfoCircle className="text-primary cursor-pointer text-lg" />
                        </Tooltip>
                      </div>
                      {/* Show Add Feedback button only if there is at least one note and not adding a note */}
                      {candidate.interviewFeedback &&
                        candidate.interviewFeedback.length > 0 &&
                        !showAddNote && (
                          <button
                            className="flex items-center gap-2 px-3 py-1 text-sm bg-primary text-white rounded-md shadow hover:bg-primary/90 transition ml-2"
                            onClick={() => setShowAddNote(true)}
                          >
                            <span className="text-lg font-bold">+</span> Add
                            Feedback
                          </button>
                        )}
                    </div>

                    <div className="mb-6">
                      <div className="flex flex-col gap-4">
                        {/* If there is no feedback, show the add note template directly */}
                        {(!candidate.interviewFeedback ||
                          candidate.interviewFeedback.length === 0) && (
                          <>
                            <div className="flex items-center gap-3 mb-4">
                              <button
                                onClick={() =>
                                  handleTemplateChange("interview")
                                }
                                className={`px-4 py-2 rounded-md text-sm font-medium transition-colors flex items-center gap-2 ${
                                  selectedTemplate === "interview"
                                    ? "border-2 border-primary/10 text-primary bg-transparent"
                                    : "text-gray-700 border-2 border-gray-200"
                                }`}
                              >
                                <AiOutlineForm className="text-lg" />
                                Interview Notes
                              </button>
                              <button
                                onClick={() => handleTemplateChange("feedback")}
                                className={`px-4 py-2 rounded-md text-sm font-medium transition-colors flex items-center gap-2 ${
                                  selectedTemplate === "feedback"
                                    ? "border-2 border-primary/10 text-primary bg-transparent"
                                    : "text-gray-700 border-2 border-gray-200"
                                }`}
                              >
                                <AiOutlineFileText className="text-lg" />
                                Application Feedback
                              </button>
                              <button
                                onClick={() => handleTemplateChange("comments")}
                                className={`px-4 py-2 rounded-md text-sm font-medium transition-colors flex items-center gap-2 ${
                                  selectedTemplate === "comments"
                                    ? "border-2 border-primary/10 text-primary bg-transparent"
                                    : "text-gray-700 border-2 border-gray-200"
                                }`}
                              >
                                <AiOutlineComment className="text-lg" />
                                General Comments
                              </button>
                            </div>
                            <div className="h-64">
                              <ReactQuill
                                theme="snow"
                                value={content}
                                onChange={setContent}
                                modules={quillModules}
                                formats={quillFormats}
                                className="h-48"
                                ref={quillRef}
                              />
                            </div>
                            <div className="flex justify-end mt-3 gap-2">
                              <button
                                className="px-3 py-1 text-sm text-gray-600 hover:text-gray-800"
                                onClick={() => {
                                  setContent(templates[selectedTemplate]);
                                  setShowAddNote(false);
                                }}
                              >
                                Cancel
                              </button>
                              <button
                                className="bg-primary text-white px-4 py-2 rounded-lg hover:bg-primary/90 transition-colors"
                                onClick={async () => {
                                  if (!content.trim()) return;
                                  const response =
                                    await RecuiterStore.updateApplicantInterviewFeedback(
                                      candidate.id,
                                      [
                                        ...(Array.isArray(
                                          candidate.interviewFeedback,
                                        )
                                          ? candidate.interviewFeedback
                                          : []),
                                        { feedback: content },
                                      ],
                                    );
                                  if (response) {
                                    setContent(templates[selectedTemplate]);
                                    setShowAddNote(false);
                                    RecuiterStore.fetchApplicantDetails(
                                      candidate.id,
                                    );
                                  }
                                }}
                              >
                                Submit Note
                              </button>
                            </div>
                          </>
                        )}
                        {/* Show notes if present */}
                        {candidate.interviewFeedback &&
                          candidate.interviewFeedback.length > 0 && (
                            <>
                              {/* If showAddNote is true, show the template (for adding more notes) */}
                              {showAddNote && (
                                <>
                                  <div className="flex items-center gap-3 mb-4">
                                    <button
                                      onClick={() =>
                                        handleTemplateChange("interview")
                                      }
                                      className={`px-4 py-2 rounded-md text-sm font-medium transition-colors flex items-center gap-2 ${
                                        selectedTemplate === "interview"
                                          ? "border-2 border-primary/10 text-primary bg-transparent"
                                          : "text-gray-700 border-2 border-gray-200"
                                      }`}
                                    >
                                      <AiOutlineForm className="text-lg" />
                                      Interview Notes
                                    </button>
                                    <button
                                      onClick={() =>
                                        handleTemplateChange("feedback")
                                      }
                                      className={`px-4 py-2 rounded-md text-sm font-medium transition-colors flex items-center gap-2 ${
                                        selectedTemplate === "feedback"
                                          ? "border-2 border-primary/10 text-primary bg-transparent"
                                          : "text-gray-700 border-2 border-gray-200"
                                      }`}
                                    >
                                      <AiOutlineFileText className="text-lg" />
                                      Application Feedback
                                    </button>
                                    <button
                                      onClick={() =>
                                        handleTemplateChange("comments")
                                      }
                                      className={`px-4 py-2 rounded-md text-sm font-medium transition-colors flex items-center gap-2 ${
                                        selectedTemplate === "comments"
                                          ? "border-2 border-primary/10 text-primary bg-transparent"
                                          : "text-gray-700 border-2 border-gray-200"
                                      }`}
                                    >
                                      <AiOutlineComment className="text-lg" />
                                      General Comments
                                    </button>
                                  </div>
                                  <div className="h-64">
                                    <ReactQuill
                                      theme="snow"
                                      value={content}
                                      onChange={setContent}
                                      modules={quillModules}
                                      formats={quillFormats}
                                      className="h-48"
                                      ref={quillRef}
                                    />
                                  </div>
                                  <div className="flex justify-end mt-3 gap-2">
                                    <button
                                      className="px-3 py-1 text-sm text-gray-600 hover:text-gray-800"
                                      onClick={() => {
                                        setContent(templates[selectedTemplate]);
                                        setShowAddNote(false);
                                      }}
                                    >
                                      Cancel
                                    </button>
                                    <button
                                      className="bg-primary text-white px-4 py-2 rounded-lg hover:bg-primary/90 transition-colors"
                                      onClick={async () => {
                                        if (!content.trim()) return;
                                        const response =
                                          await RecuiterStore.updateApplicantInterviewFeedback(
                                            candidate.id,
                                            [
                                              ...(Array.isArray(
                                                candidate.interviewFeedback,
                                              )
                                                ? candidate.interviewFeedback
                                                : []),
                                              { feedback: content },
                                            ],
                                          );
                                        if (response) {
                                          setContent(
                                            templates[selectedTemplate],
                                          );
                                          setShowAddNote(false);
                                          RecuiterStore.fetchApplicantDetails(
                                            candidate.id,
                                          );
                                        }
                                      }}
                                    >
                                      Submit Note
                                    </button>
                                  </div>
                                </>
                              )}
                              {/* Always show notes */}
                              {candidate.interviewFeedback.map(
                                (feedback, index) => (
                                  <div
                                    key={index}
                                    className="relative bg-white rounded-xl shadow-md  p-5 mb-4 transition-transform duration-200  hover:shadow-lg flex flex-col"
                                  >
                                    {/* Note heading and actions at the top */}
                                    <div className="flex items-center justify-between mb-2">
                                      <span className="text-base font-bold text-primary">
                                        Note {index + 1}
                                      </span>
                                      {editingFeedback !== index && (
                                        <div className="flex gap-2">
                                          <button
                                            className="p-2 rounded-full hover:bg-primary/10 transition"
                                            title="Edit Feedback"
                                            onClick={() =>
                                              handleEditFeedback(
                                                feedback,
                                                index,
                                              )
                                            }
                                          >
                                            <FaRegEdit className="text-primary" />
                                          </button>
                                          <button
                                            className="p-2 rounded-full hover:bg-red-100 transition"
                                            title="Delete Feedback"
                                            onClick={() =>
                                              handleDeleteFeedback(index)
                                            }
                                          >
                                            <FaRegTrashAlt className="text-red-500" />
                                          </button>
                                        </div>
                                      )}
                                    </div>
                                    {/* Show editable text box when editing */}
                                    {editingFeedback === index ? (
                                      <>
                                        <div className="h-64 mb-3">
                                          <ReactQuill
                                            theme="snow"
                                            value={editContent}
                                            onChange={setEditContent}
                                            modules={quillModules}
                                            formats={quillFormats}
                                            className="h-48"
                                            ref={quillRef}
                                          />
                                        </div>
                                        <div className="flex justify-end gap-2 mt-3">
                                          <button
                                            className="px-3 py-1 text-sm text-gray-600 hover:text-gray-800"
                                            onClick={() => {
                                              setEditingFeedback(null);
                                              setEditContent("");
                                            }}
                                          >
                                            Cancel
                                          </button>
                                          <button
                                            className="bg-primary text-white px-4 py-2 rounded-lg hover:bg-primary/90 transition-colors"
                                            onClick={() =>
                                              handleUpdateFeedback(index)
                                            }
                                          >
                                            Save Changes
                                          </button>
                                        </div>
                                      </>
                                    ) : (
                                      <>
                                        {/* Note content, no scroll */}
                                        <div className="prose max-w-none text-gray-800 bg-gray-50 rounded p-3 mb-3">
                                          <div
                                            dangerouslySetInnerHTML={{
                                              __html: feedback.feedback,
                                            }}
                                          />
                                        </div>
                                        <span className="text-xs text-gray-400">
                                          {(() => {
                                            const date = new Date(
                                              feedback.createdAt,
                                            );
                                            const day = date.getDate();
                                            const month = date
                                              .toLocaleString("default", {
                                                month: "short",
                                              })
                                              .toLowerCase();
                                            const year = date
                                              .getFullYear()
                                              .toString()
                                              .slice(-2);
                                            return `${day} ${month},${year}`;
                                          })()}
                                        </span>
                                      </>
                                    )}
                                  </div>
                                ),
                              )}
                            </>
                          )}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* <ReportCard {...reportData1[0]} /> */}
            </div>
          </div>
        </div>

        {/* <div className="w-full justify-end mr-10">
          <div className="flex flex-row justify-end mr-6 sm:mr-14 md:mr-16 lg:mr-24 pb-10">
            <CandidateButtons
              fromMainPage={true}
              id={recruiter?._id}
              handleReject={() => {
                updateCandidateStatus(false);
                setSub(Rejectsubject);
                setContent(Rejectmessage);
                PopupStore.setMail(true);
              }}
              handleShortlist={() => {
                updateCandidateStatus(true);
                setSub(subject);
                setContent(message);
                PopupStore.setMail(true);
              }}
            />
          </div>
        </div> */}
      </div>

      {/* Proxy Image Popups */}
      <ProxyImagePopup
        isOpen={showFaceOutOfViewPopup}
        onClose={() => setShowFaceOutOfViewPopup(false)}
        isJobPost={isJobPost}
        hrImages={
          candidate?.proxy?.hrInterviewProxyId?.faceOutOfView?.proofs || []
        }
        technicalImages={
          candidate?.proxy?.technicalInterviewProxyId?.faceOutOfView?.proofs ||
          []
        }
        codingImages={
          candidate?.proxy?.codingInterviewProxyId?.faceOutOfView?.proofs || []
        }
        mockTestImages={
          candidate?.proxy?.mockTestProxyId?.faceOutOfView?.proofs || []
        }
        title="Face Out of View Detections"
      />

      <ProxyImagePopup
        isOpen={showMultipleFacesPopup}
        onClose={() => setShowMultipleFacesPopup(false)}
        isJobPost={isJobPost}
        hrImages={
          candidate?.proxy?.hrInterviewProxyId?.multipleFacesDetected?.proofs.slice(
            1,
          ) || []
        }
        technicalImages={
          candidate?.proxy?.technicalInterviewProxyId?.multipleFacesDetected?.proofs.slice(
            1,
          ) || []
        }
        codingImages={
          candidate?.proxy?.codingInterviewProxyId?.multipleFacesDetected?.proofs.slice(
            1,
          ) || []
        }
        mockTestImages={
          candidate?.proxy?.mockTestProxyId?.multipleFacesDetected?.proofs.slice(
            1,
          ) || []
        }
        title="Multiple Faces Detected"
      />

      {/* Text Detection Popup */}
      <TextDetectionPopup
        isOpen={showTextDetectionPopup}
        onClose={() => setShowTextDetectionPopup(false)}
        isJobPost={isJobPost}
        hrTexts={
          candidate?.proxy?.hrInterviewProxyId?.textDetection?.proofs || []
        }
        technicalTexts={
          candidate?.proxy?.technicalInterviewProxyId?.textDetection?.proofs ||
          []
        }
        codingTexts={
          candidate?.proxy?.codingInterviewProxyId?.textDetection?.proofs || []
        }
        mockTestTexts={
          candidate?.proxy?.mockTestProxyId?.textDetection?.proofs || []
        }
        title="Copy-Paste Detections"
      />

      {/* Tab Changes Popup */}
      <TabChangesPopup
        isOpen={showTabChangesPopup}
        onClose={() => setShowTabChangesPopup(false)}
        isJobPost={isJobPost}
        hrImages={
          candidate?.proxy?.hrInterviewProxyId?.tabChanges?.proofs || []
        }
        codingImages={
          candidate?.proxy?.codingInterviewProxyId?.tabChanges?.proofs || []
        }
        technicalImages={
          candidate?.proxy?.technicalInterviewProxyId?.tabChanges?.proofs || []
        }
        mockTestImages={
          candidate?.proxy?.mockTestProxyId?.tabChanges?.proofs || []
        }
        title="Tab Changes Detections"
      />

      {/* Verification Popup */}
      <VerificationPopup
        isOpen={showVerificationPopup}
        onClose={() => {
          setShowVerificationPopup(false);
          setEditingVerification(null);
        }}
        applicationId={candidate?.id}
        userId={candidate?.userId || candidate?._id}
        verificationData={editingVerification}
        isEdit={!!editingVerification}
        onSuccess={(data) => {
          setVerificationData(data);
          setShowVerificationPopup(false);
          setEditingVerification(null);
        }}
      />
    </div>
  ));
};

export default ReportOverview;

// for the buttons
export function CandidateButtons({
  ismobile,
  fromMainPage,
  id,
  handleReject,
  handleShortlist,
}) {
  const { RecuiterStore, PopupStore } = useStores();

  const updateCandidateStatus = (status) => {
    console.log(status);
    RecuiterStore.ChangeApplicantStatus(status);
  };

  return useObserver(() => (
    <>
      {JSON.parse(localStorage.getItem("user"))?._id === id ? (
        <div
          className={`${
            ismobile
              ? `flex justify-end md:hidden lg:hidden`
              : `${fromMainPage ? "flex" : "hidden"} md:flex lg:flex`
          } mt-auto mb-[2%] space-x-4`}
        >
          {/* <PrimaryButton
            buttonName={"Reject"}
            color={"#FF6B00"}
            onClick={handleReject}
          />
          <PrimaryButton
            buttonName={"Shortlist"}
            color={"#20BF55"}
            onClick={handleShortlist}
          /> */}
        </div>
      ) : (
        <></>
      )}
    </>
  ));
}
